import * as Sentry from '@sentry/react'
import { logger } from './logger'

export const captureSentryError = (
  err: unknown,
  options?: { message?: string; data?: Record<string, unknown> },
) => {
  logger.error(options?.message || 'Error occurred', err, options?.data)

  const sessionURL = logger.getSessionURL()

  Sentry.captureException(err, (scope) => {
    if (options?.message) {
      scope.addBreadcrumb({
        category: 'error',
        message: options.message,
        level: 'error',
      })
    }

    if (options?.data) {
      scope.setContext('data', options.data)
    }

    if (sessionURL) {
      scope.setTag('logrocket_session', sessionURL)
    }

    return scope
  })
}
